import {Controller} from "@/controllers/Controller";

/**
 * Controller for group API
 */
export class GroupController extends Controller {

    static post(body){
        return this.requestBuilder("POST",`/user/groups`, true, body);
    }

    static patch(groupId, body){
        return this.requestBuilder("PATCH",`/user/groups/${groupId}`, true, body, {});
    }

    static get(groupId){
        return this.requestBuilder("GET",`/user/groups/${groupId}`, true);
    }

    static getForAccountant(){
        return this.requestBuilder("GET",`/user/groups/accountant/table`, true);
    }

    static async linkAccountantToGroup(token) {
        return this.requestBuilder("PATCH",`/user/groups/accountant/link-accountant-to-group/${token}`, true);
    }

    static async generateTokenForLinkAccountantToGroup() {
        return this.requestBuilder("GET",`/user/groups/accountant/generate-token-for-link-accountant-to-group`, true);
    }
}
